// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BLOGS_ADD_NEW_COMMENT_PLACEHOLDER = "Za\u010dni p\u00edsa\u0165 koment\u00e1r...";
export const SEND_COMMENT_FORUM = "Odo\u0161li";
